import React from 'react';
import {Form} from 'react-final-form';
import {useIntl} from 'react-intl';

import {EEventSource} from 'coreClasses/events/IEvents';
import {useProductSubscription} from 'coreHooks';
import validationRules from 'coreUtils/validationRules';

import Button from 'brandComponents/Button';
import Field from 'brandComponents/Form/Subcomponents/Field';
import {NEWSLETTER_SOURCE} from 'brandConstants';

import {INotifyMeFormProps} from './INotifyMeForm';
import messages from './messages';

const NotifyMeForm = ({
	pid,
	onSuccess,
	onError,
	classNames,
	submitBtnText = '',
}: INotifyMeFormProps) => {
	const intl = useIntl();
	const productSubscription = useProductSubscription();
	const nlSubscriptionSrc: string = EEventSource[EEventSource.NOTIFY_ME_POPUP];

	const onSubmit = async ({email, pid, acceptsMarketing}) => {
		const newsletterSource = {
			newsletterSource: NEWSLETTER_SOURCE[nlSubscriptionSrc],
			newsletterSourceDetails: {
				pageType: NEWSLETTER_SOURCE.CUSTOM_NOTIFY_ME
			}
		};
		productSubscription.subscribe(
			email,
			pid,
			acceptsMarketing,
			newsletterSource
		)
			.then(() => onSuccess && onSuccess())
			.catch(() => onError && onError());
	};

	return (
		<Form
			onSubmit={(values: {email: string; pid: string, acceptsMarketing: boolean|null}) => onSubmit(values)}
			render={({handleSubmit, submitting}) => (
				<form onSubmit={handleSubmit}>
					<Field name="pid" type="hidden" initialValue={pid} />
					<Field
						id="notify-email"
						name="email"
						type="email"
						component="input"
						label={intl.formatMessage(messages.emailPlaceholder)}
						validation={[
							{
								rule: validationRules.isRequired,
								errorMessage: intl.formatMessage(messages.emailRequiredError),
							},
							{
								rule: validationRules.isEmail,
								errorMessage: intl.formatMessage(messages.emailInvalidError),
							},
						]}
					/>
					<Field
						name="acceptsMarketing"
						type="checkbox"
						label={intl.formatMessage(messages.newsletter)}
						initialValue
					/>
					<Button
						type="submit"
						classNames={classNames?.submitButton}
						disabled={submitting}
						variant="primary"
						full-width
					>
						{submitBtnText || intl.formatMessage(messages.submitBtnText)}
					</Button>
				</form>
			)}
		/>
	);
};

export default NotifyMeForm;
